// @ts-nocheck
import React from "react";

import { OrderType } from "../../../context/order/AdminOrdersContext";

import UncompletedOrderCard from "./UncompletedOrderCard.tsx";
import CompletedOrderCard from "./CompletedOrderCard.tsx";

const CompletedOrdersTab: React.FC<{ orders: OrderType }> = ({ orders,statusUpdater,setStatusUpdater }) => {
  return (
    <div className="admin-order-panel completed-orders">
      {orders?.map((value, index) => (
        <CompletedOrderCard
        statusUpdater={statusUpdater} setStatusUpdater={setStatusUpdater}
          order={value}
          key={`completed-orders${index}`}
          index={index}
        />
      ))}
    </div>
  );
};

const WaitingOrdersTab: React.FC<{ orders: OrderType }> = ({
  orders,
  pageName,
  statusUpdater,
  setStatusUpdater
}) => {
  return (
    <div className="admin-order-panel waiting-orders">
      {orders?.map((value, index) => (
        <UncompletedOrderCard
        statusUpdater={statusUpdater} setStatusUpdater={setStatusUpdater}
          order={value}
          key={`uncompleted-orders${index}`}
          index={index}
          pageName={pageName}
        />
      ))}
    </div>
  );
};

export { CompletedOrdersTab, WaitingOrdersTab };
